import * as React from "react";
import type { SVGProps } from "react";
const SvgCloud03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.36 18.72H7.2a4.8 4.8 0 0 1-1.363-9.404 6.72 6.72 0 0 1 12.829 1.832 3.84 3.84 0 0 1-.906 7.572z"
    />
  </svg>
);
export default SvgCloud03;
